import request from "./request";

// 活动
export function getActivity() {
  return request({
    url: "/hkweb/content/index",
    method: "get",
  });
}


// 协议
export function agreementList(data) {
  return request(
    {
      url: "/hkweb/sys/agreement",
      method: "post",
      data
    },
    false
  );
}


//Whois查询
export function getWhois(params) {
  return request(
    {
      url: "/hkweb/dn/lastWhoisInfo",
      method: "get",
      params
    },
    false
  );
}

//Whois查询
export function getCaptchaWhoisV1(domain) {
  return request(
      {
        url: `/hkweb/sys/captcha/whois/${domain}`,
        method: "get",
      },
      false
  );
}

//Whois查询
export function getCaptchaWhoisV2(domain, id, vCode) {
  return request(
      {
        url: `/hkweb/sys/captcha/whois/${domain}/${id}/${vCode}`,
        method: "get",
      },
      false
  );
}

// 域名后缀(二级)
export function getDomainSuffix() {
  return request({
    url: "/hkweb/dn/houzhui",
    method: "get",
  });
}

// 获取敏感词
export function sensitiveWords() {
  return request(
    {
      url: "/hkweb/dn/sensitiveWords",
      method: "post",
    },
    false
  );
}

// 域名注册查询
export function searchDomain(data) {
  return request(
    {
      url: "/hkweb/dn/jc",
      method: "post",
      data,
    },
    true
  );
}

//域名价格
export function getPriceList(type) {
  return request(
    {
      url: "/hkweb/dn/jg/" + type,
      method: "get",
    },
    false
  );
}

//加入购物车
export function addShopCart(data) {
  return request({
    url: "/hkweb/cart/save",
    data,
    method: "post",
    isToken: true,
  });
}

// 查询模板
export function getTemplates(params) {
  return request({
    url: "/hkweb/dn/templates/page/etrieve",
    params,
    method: "get",
    isToken: true,
  });
}

// 购物车查询
export function getShoppingCart(params) {
  return request({
    url: "/hkweb/cart/getList",
    params,
    method: "get",
    isToken: true,
  });
}

// 修改年限
export function orderCountEdit(data) {
  return request({
    url: "/hkweb/cart/year",
    data,
    method: "post",
    isToken: true,
  });
}

// 购物车删除
export function delectShopCart(data) {
  return request({
    url: "/hkweb/cart/delete",
    data,
    method: "DELETE",
    isToken: true,
  });
}

// 模板删除
export function delectTemplates(templateId) {
  return request({
    url: `/hkweb/dn/templates/delete/${templateId}`,
    method: "DELETE",
    isToken: true,
  });
}

// 创建订单
export function createOrder(data) {
  return request({
    url: "/hkweb/cart/order/save",
    data,
    method: "post",
    isToken: true,
  });
}

// 支付订单
export function pay(data) {
  return request({
    url: "/hkweb/pay",
    data,
    method: "post",
    isToken: true,
  });
}

// 获取支付订单
export function orderPayOrder(params) {
  return request({
    url: "/hkweb/order/pay/get",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名查询条件
export function domainQuery() {
  return request({
    url: "/hkweb/dn/cxtj",
    method: "get",
    isToken: true,
  });
}

// 域名品类
export function domainTypeList() {
  return request({
    url: "/hkweb/dn/gc",
    method: "get",
    isToken: true,
  });
}

// 我的域名
export function domainList(params) {
  return request({
    url: "/hkweb/dn/my/retrieve",
    params,
    method: "get",
    isToken: true,
  });
}

// 分页查询
export function templatesList(params) {
  return request({
    url: "/hkweb/dn/templates/page/etrieve",
    params,
    method: "get",
    isToken: true,
  });
}

// 我的模板-根据模板查看域名列表
export function templatesDomainList(params) {
  return request({
    url: "/hkweb/dn/templates/one",
    params,
    method: "get",
    isToken: true,
  });
}

// 删除模板
export function deleteTemplate(params) {
  return request({
    method: "delete",
    url: `/hkweb/dn/templates/delete/${params}`,
    isToken: true,
  });
}

// 复制模板
export function getTemplateCopy(params) {
  return request({
    url: "/hkweb/dn/templates/copy",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取邮箱，企业，个人认证
export function getcertifiedInformation() {
  return request({
    url: "/hkweb/rz/verifyInfo",
    method: "get",
    isToken: true,
  });
}

// 获取中国地区城市
export function getRegionList() {
  return request({
    url: "/hkweb/client/area",
    method: "get",
    isToken: true,
  });
}

// 查询默认模板
export function getTemplatesDefault() {
  return request({
    url: "/hkweb/dn/templates/default/retrieve",
    method: "get",
    isToken: true,
  });
}

// 提交模板
export function templatesSave(data) {
  return request({
    url: "/hkweb/dn/templates/create",
    data, // post
    method: "post",
    isToken: true,
  });
}

// 提交默认模板
export function templatesDefaultSave(data) {
  return request({
    url: "/hkweb/dn/templates/default/create",
    params: data, // post query参数
    method: "post",
    isToken: true,
  });
}

// 模板过户
export function templatesTransfer(data) {
  return request({
    url: "/hkweb/dn/templates/push",
    data,
    method: "post",
    isToken: true,
  });
}

// 模板过户记录
export function getTemplatesTransferList(params) {
  return request({
    url: "/hkweb/dn/templates/push/retrieve",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出记录
export function getTransferOutList(params) {
  return request({
    url: "/hkweb/dn/transferOut/retrieve",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出-重新索取转移码
export function transferOutRefreshCode(params) {
  return request({
    url: "/hkweb/dn/transferOut/code/new",
    params,
    method: "post",
    isToken: true,
  });
}

// 转出-取消转出
export function transferOutCancel(params) {
  return request({
    url: "/hkweb/dn/transferOut/cancel",
    params,
    method: "DELETE",
    isToken: true,
  });
}

// 转出-同意转出
export function transferOutConsent(params) {
  return request({
    url: "/hkweb/dn/transferOut/agree",
    params,
    method: "post",
    isToken: true,
  });
}

// 转出-查询状态
export function transferOutQueryStatus(params) {
  return request({
    url: "/hkweb/dn/transferOut/status",
    params,
    method: "get",
    isToken: true,
  });
}

// 转入记录
export function transferIntoList(params) {
  return request({
    url: "/hkweb/dn/transferInto/retrieve",
    params,
    method: "get",
    isToken: true,
  });
}

// 转入-修改转移码
export function transferIntoEdit(data) {
  return request({
    url: "/hkweb/dn/transferInto/code/update",
    data,
    method: "post",
    isToken: true,
  });
}

// 转出-查询状态
export function transferIntoDetail(params) {
  return request({
    url: "/hkweb/dn/transferInto/status",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出-检测域名
export function transferOutCheckDomain(params) {
  return request({
    url: "/hkweb/dn/transferOut/verify/step1",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出-检测手机
export function transferOutCheckMobile(data) {
  return request({
    url: "/hkweb/dn/transferOut/verify/step2",
    data,
    method: "post",
    isToken: true,
  });
}

// 转出-获取转移码
export function transferOutTransferCode(data) {
  return request({
    url: "/hkweb/dn/transferOut/verify/step3",
    params: data, // post query参数
    method: "post",
    isToken: true,
  });
}

// 转入-检测手机
export function transferIntoSave(data) {
  return request({
    url: "/hkweb/dn/transferInto/create",
    data,
    method: "post",
    isToken: true,
  });
}

// PUSH-检测用户是否存在
export function userCheck(params) {
  return request({
    url: "/hkweb/client/check",
    params,
    method: "get",
    isToken: true,
  });
}

// PUSH
export function pushCreate(data) {
  return request({
    url: "/hkweb/dn/push/create",
    data,
    method: "post",
    isToken: true,
  });
}

// PUSH-分页查询
export function pushPageList(params) {
  return request({
    url: "/hkweb/dn/push/retrieve",
    params,
    method: "get",
    isToken: true,
  });
}

// PUSH-操作
export function pushEdit(data) {
  return request({
    url: "/hkweb/dn/push/submit",
    data,
    method: "post",
    isToken: true,
  });
}

// 域名订单列表
export function orderPageList(params) {
  return request({
    url: "/hkweb/order/domain/get",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名订单-取消订单
export function orderCancel(data) {
  return request({
    url: "/hkweb/order/cancel",
    params: data,
    method: "post",
    isToken: true,
  });
}

// 域名订单-订单详情
export function orderDetail(params) {
  return request({
    url: "/hkweb/order/detail",
    params,
    method: "get",
    isToken: true,
  });
}

// 设置隐私保护
export function domainSetPrivacy(data) {
  return request({
    url: `/hkweb/dn/protected`,
    data,
    method: "post",
    isToken: true,
  });
}

// 我的域名-自动续费
export function domainAutoRenew(data) {
  return request({
    url: `/hkweb/dn/renew/auto`,
    data,
    method: "post",
    isToken: true,
  });
}

// 例行维护公告
export function serverUpdate() {
  return request(
    {
      url: "/hkweb/content/serverUpdate",
      method: "post",
      isToken: true,
    },
  );
}
